import { Tab, Tabs, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import cuideoTheme from "../../../../containers/themes/defaultTheme";
import ClientDiscardedValuationsTable from "./ClientDiscardedValuationsTable";

/**
 * ECO-1237: the tab only holds the client discards for now, but it is the
 * home of every valuation listing to come, hence the sub-tabs.
 */
export type TValuationsTabSubTab = "client_discarded";

const StyledWrapper = styled.div`
  margin: 1rem;
  max-width: 71.75rem;
`;

const StyledHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 2rem 0 1rem;
  justify-content: space-between;
`;

const StyledTitle = styled(Typography)`
  color: ${cuideoTheme.palette.primary.main};
  font-size: 1.875rem;
  font-weight: 700;
`;

const StyledSubTabs = styled(Tabs)`
  margin: 0 0 1rem;
  border-bottom: 1px solid rgba(0, 72, 120, 0.2);

  .MuiTabs-indicator {
    background-color: #ebc200;
  }
`;

const StyledSubTab = styled(Tab)`
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: none;
`;

interface IValuationsTabProps {
  candidato: {
    id: string;
  };
}

const ValuationsTab = (props: IValuationsTabProps) => {
  const { candidato } = props;
  const [subTab, setSubTab] =
    useState<TValuationsTabSubTab>("client_discarded");

  const handleSubTabChange = (
    event: React.ChangeEvent<{}>,
    newValue: TValuationsTabSubTab
  ) => {
    setSubTab(newValue);
  };

  return (
    <StyledWrapper>
      <StyledHeader>
        <StyledTitle>
          <FormattedMessage
            id="ValuationsTab.Valuations"
            defaultMessage="Valoraciones"
          />
        </StyledTitle>
      </StyledHeader>
      <StyledSubTabs
        value={subTab}
        textColor="primary"
        onChange={handleSubTabChange}
      >
        <StyledSubTab
          value="client_discarded"
          label={
            <FormattedMessage
              id="ValuationsTab.ClientDiscarded"
              defaultMessage="Descartados por cliente"
            />
          }
        />
      </StyledSubTabs>
      {subTab === "client_discarded" && (
        <ClientDiscardedValuationsTable candidateId={candidato.id} />
      )}
    </StyledWrapper>
  );
};

export default ValuationsTab;
